export default "__VITE_ASSET__1uIca21j__"